import { Link } from 'react-router-dom';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import type { MediaStorageStatus } from '@/lib/mediaStorage';
import { formatMediaBytes } from '@/lib/mediaStorage';

type Props = {
  open: boolean;
  onClose: () => void;
  status: MediaStorageStatus | null;
  variant: 'blocked' | 'warn';
};

export function MediaQuotaModal({ open, onClose, status, variant }: Props) {
  const quota = status?.quota_bytes ?? null;
  const usage = status?.usage_bytes ?? 0;

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={variant === 'blocked' ? '本地空间已满' : '本地空间即将用尽'}
    >
      <div className="space-y-4 text-sm text-slate-600">
        <p>
          {variant === 'blocked'
            ? '已达到多媒体本地存储限额，无法继续上传或更换图片。请配置 OSS 并迁移现有资源，或联系管理员提升限额。'
            : '本地多媒体占用已超过限额 80%。建议尽快切换到 OSS，避免达到上限后无法上传。'}
        </p>
        {quota != null ? (
          <p className="rounded-lg bg-slate-50 px-3 py-2 text-slate-700">
            已用 <strong>{formatMediaBytes(usage)}</strong> / 限额 <strong>{formatMediaBytes(quota)}</strong>
          </p>
        ) : null}
        <div className="flex flex-wrap gap-2">
          <Link to="/oss" onClick={onClose}>
            <Button type="button" variant="primary">
              前往 OSS 设置
            </Button>
          </Link>
          <Button type="button" variant="secondary" onClick={onClose}>
            关闭
          </Button>
        </div>
      </div>
    </Modal>
  );
}
